import styled from "@emotion/styled";

import { fontSourceSerif4, theme } from "shared/lib/styles";

import { StyledArticleComment } from "scmp-app/components/content/content-action-bar/styles";
import { EntityLink } from "scmp-app/components/entity-link";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  color: #000000;
`;

export const StyledEntityLink = styled(EntityLink)``;

export const Headline = styled.div`
  color: #000000;
  font-weight: 600;
  font-size: 18px;
  font-family: ${fontSourceSerif4};
  line-height: 120%;
  letter-spacing: -2%;

  ${theme.breakpoints.up("tablet")} {
    font-size: 20px;
  }
`;

export const ActionBar = styled.div`
  time,
  ${StyledArticleComment} {
    font-size: 11px;
    line-height: 100%;
    letter-spacing: 0%;
  }

  time {
    color: #727272;
  }
`;

export const HeadlineContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LiveTagContainer = styled.div`
  margin-block-end: 8px;

  :empty {
    margin-block-end: 0;
  }
`;
